
















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Promo, Product } from '@/store/modules/lib';

@Component
export default class LinkItem extends Vue {

  @Prop({ type: Boolean, default: false }) protected noBorder!: boolean;
  @Prop({ type: Object, default: {} }) protected link!: Promo;

}

